export const api = "https://tms.typ.delivery";

export const baseUrl = "/api/v1";

export const API_ROOT_URL = api + baseUrl;
